const replaceUrlPlaceholders = (url) =>
	url
		.replace(
			'%url%',
			encodeURIComponent(
				`${window.location.protocol}://${window.location.host}${window.location.pathname}`
			)
		)
		.replace('%title%', encodeURIComponent(document.title));

class ShareButtons {
	constructor(el) {
		el.querySelectorAll('.share-buttons__button').forEach(
			(button) =>
				(button.href = replaceUrlPlaceholders(button.dataset.shareUrl))
		);
	}
}

document
	.querySelectorAll('.wp-block-occasions-share-buttons')
	.forEach((el) => new ShareButtons(el));
